

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const LOGINPOST= createAsyncThunk(
  "LoginPost/LoginPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const LoginPostSlice = createSlice({
  name: "LoginPostSlice",
  initialState: {
    LoginPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfLoginPost: (state) => {
        state.LoginPost.loading = false
        state.LoginPost.error = false
        state.LoginPost.data = []
        state.LoginPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(LOGINPOST.fulfilled, (state, action) => {
      state.LoginPost = {
        ...state.LoginPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINPOST.pending, (state, action) => {
      state.LoginPost = {
        ...state.LoginPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINPOST.rejected, (state, action) => {
      state.LoginPost = {
        ...state.LoginPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const LoginPostAction = {
    LOGINPOST,
};

export { LoginPostAction };
export default LoginPostSlice.reducer;
export const {setInitialStateOfLoginPost} = LoginPostSlice.actions
